// extracted by mini-css-extract-plugin
export var borderTop = "_i-3";
export var linkIcon = "_i-5";
export var linkIconSm = "_i-6";
export var linkOutCard = "_i-7 _i-4";
export var linkRow = "_i-2";
export var pageContainer = "_i-1";
export var providerIcon = "_i-8";
export var roundedBorder = "_i-4";
export var settingsContent = "_i-0";